import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type { LinkProps } from '@/lib/navigation';

const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(
  { href, children, ...rest },
  ref
) {
  return (
    <RouterLink to={href} ref={ref} {...rest}>
      {children}
    </RouterLink>
  );
});

export default Link;
